import React, { Component } from "react";
import PropTypes from "prop-types";

class Loader extends Component {
	render() {
		return (
			<div className="dna-loader">
				<div className="nucleobase"></div>
				<div className="nucleobase"></div>
				<div className="nucleobase"></div>
				<div className="nucleobase"></div>
				<div className="nucleobase"></div>
				<div className="nucleobase"></div>
				<div className="nucleobase"></div>
				<div className="nucleobase"></div>
				<div className="nucleobase"></div>
				<div className="nucleobase"></div>
			</div>
		);
	}
}
Loader.propTypes = {
	name: PropTypes.string,
	onSelect: PropTypes.func,
	itemKey: PropTypes.string,
};
export default Loader;
